module.exports = __webpack_public_path__ + "img/facebook.7428c0e4.png";